import { EventEmitter, Input, Output } from '@angular/core';
import { ompFieldIsEmpty } from '../omp.utils';

// Shared inputs/output + data setter for every OMP section-settings component.
export abstract class OmpSectionSettings {
  @Input() data: any;
  @Output() change = new EventEmitter<void>();

  isEmpty(field: string): boolean {
    return ompFieldIsEmpty(this.data ? this.data[field] : null);
  }

  set(field: string, value: any) {
    if (this.data) {
      this.data[field] = value;
    }
    this.change.emit();
  }
}
